import { AdvancedMarker, Pin } from '@vis.gl/react-google-maps'

export const SearchMarker = ({
    lat,
    lng,
}) => {
    return (
        <AdvancedMarker position={{ lat: +lat, lng: +lng }}>
            <Pin background={'#ED2626'} glyphColor={'#FFF'} borderColor={'#ED2626'} />
        </AdvancedMarker>
    )
}
